import { Component } from '@angular/core';

@Component({
    selector: 'app-nav-rail-content',
    templateUrl: './nav-rail-content.component.html',
    styleUrls: ['./nav-rail-content.component.scss'],
    standalone: true
})
export class NavRailContentComponent {

}
